import { Component, OnInit, OnDestroy, DoCheck } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterOutlet, ActivatedRoute } from "@angular/router";
import { AuthService } from "./core/services/auth.service";
import { Formio } from "@formio/angular";
import { LoadingComponent } from "./shared/components/loading/loading.component";
import { Subscription } from "rxjs";
import { PdfViewerModule } from "ng2-pdf-viewer";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [CommonModule, RouterOutlet, LoadingComponent, PdfViewerModule],
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Patient Management System";
  isLoggedIn = false;
  isProcessingSaml = false;
  private authSubscription: Subscription | null = null;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {}
 private renderCount = 0;


  ngOnInit(): void {
    this.handleSamlCallback();
    if (!this.isProcessingSaml) {
      this.authService.processUrlParameters(window.location.href);
      this.isLoggedIn = this.authService.isAuthenticated();
      const token = this.authService.getToken();
      if (token) {
        Formio.setToken(token);
      }
    }

    this.authSubscription = this.authService.authState$.subscribe(
      (loggedIn) => {
        this.isLoggedIn = loggedIn;
      }
    );
  }

  /**
   * Handle SAML callback
   */
  private handleSamlCallback(): void {
    // Check URL for SAML token
    const urlParams = new URLSearchParams(window.location.search);
    const samlToken = urlParams.get("saml");

    if (samlToken) {
      this.isProcessingSaml = true;
      console.log("Processing SAML token at app level...");

      // Process the SAML token
      this.authService.loginWithSaml(samlToken).subscribe({
        next: (success) => {
          if (success) {
            console.log("SAML authentication successful");

            // Clear the SAML token from URL
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);

            // Navigate to patients page
            this.router.navigate(["/patients"]);
          } else {
            console.error("SAML authentication failed");
            // Clear the SAML token from URL
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);

            // Navigate to login with error
            this.router.navigate(["/login"], {
              queryParams: { error: "saml_failed" },
            });
          }
          this.isProcessingSaml = false;
        },
        error: (err) => {
          console.error("SAML authentication error:", err);

          // Clear the SAML token from URL
          const newUrl = window.location.origin + window.location.pathname;
          window.history.replaceState({}, document.title, newUrl);

          // Navigate to login with error
          this.router.navigate(["/login"], {
            queryParams: { error: "saml_error" },
          });
          this.isProcessingSaml = false;
        },
      });
    }
  }

  ngOnDestroy(): void {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(["/login"]);
  }
}